// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__KjNiF","inner":"Header_inner__TFKuI","link":"Header_link__4GDCr","linkLabel":"Header_linkLabel__SctWz"};